import { render, staticRenderFns } from "./AddChild.vue?vue&type=template&id=ba822ad4&scoped=true&"
import script from "./AddChild.vue?vue&type=script&lang=js&"
export * from "./AddChild.vue?vue&type=script&lang=js&"
import style0 from "./AddChild.vue?vue&type=style&index=0&id=ba822ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba822ad4",
  null
  
)

export default component.exports